import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import PostForm from './PostForm';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function EditPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAuthHeader } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API_URL}/posts/admin/${id}`, {
        headers: getAuthHeader()
      });
      setPost(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching post:', error);
      toast.error('Failed to load post');
      navigate('/posts');
    }
  };

  useEffect(() => {
    fetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSuccess = () => {
    toast.success('Post updated successfully!');
    navigate('/posts');
  };

  const handleCancel = () => {
    navigate('/posts');
  };

  if (loading) {
    return <div className="loading">Loading post...</div>;
  }

  return (
    <div className="main-content">
      <div className="container">
        <PostForm 
          post={post} 
          onSuccess={handleSuccess} 
          onCancel={handleCancel} 
        />
      </div>
    </div>
  );
}

export default EditPost;